import React from 'react';
import { observer } from 'mobx-react-lite';
import { gameConfigStore } from '@pascal/pascal-core';
import { CatchMeResultImageItem } from './catchMeResultImgItem';
import { touchMeGameId } from '../../enums/gameConstant';
import { TouchMeResultImageItem } from './touchMeResultImgItem';

export const ResultImg = observer(
  ({ isFromResultHistory, dataForResultImage: { roundData, additionalParams, ...rest } }) => {
    const emptyArr = [1, 2, 3]; // TODO change hardcode
    const { gameId } = gameConfigStore;

    return (
      <div className='g-h-result-img'>
        <div className='c-m-inner-item-holder'>
          {/* For c-m-inner-item add class // failure // to change color of cloud */}
          {/* eslint-disable-next-line no-nested-ternary */}
          {roundData && !isFromResultHistory
            ? roundData.map((item, index) => {
                return touchMeGameId === +gameId ? (
                  <TouchMeResultImageItem
                    item={item}
                    key={index}
                    activeIndex={additionalParams.index}
                    odd={rest.odd}
                  />
                ) : (
                  <CatchMeResultImageItem
                    item={item}
                    key={index}
                    activeIndex={additionalParams.index}
                    odd={rest.odd}
                  />
                );
              })
            : roundData && isFromResultHistory
            ? roundData.map((item, index) => {
                return touchMeGameId === +gameId ? (
                  <TouchMeResultImageItem item={item} key={index} />
                ) : (
                  <CatchMeResultImageItem item={item} key={index} />
                );
              })
            : emptyArr.map((item, index) => {
                return touchMeGameId === +gameId ? (
                  <TouchMeResultImageItem item={item} key={index} />
                ) : (
                  <CatchMeResultImageItem item={item} key={index} />
                );
              })}
        </div>
      </div>
    );
  }
);
